<template>
    <form @submit="publish">
        <div v-if="subject.mixcloudURL || subject.wordpressURL">
            <h4>Sujet publié</h4>
            <ul>
                <li v-if="subject.wordpressURL">URL Article : <a v-bind:href="subject.wordpressURL" target="_blank">{{subject.wordpressURL}}</a></li>
                <li v-if="subject.mixcloudURL">URL Mixcloud : <a v-bind:href="subject.mixcloudURL" target="_blank">{{subject.mixcloudURL}}</a></li>
            </ul>
        </div>

        <div v-else-if="statut.name === 'CONFIRMÉ' && subject.audio">
            <h4>publication possible</h4>
            <ul>à vérifier avant publication :
                <li>titre propre</li>
                <li>orthographe description</li>
                <li>tags cohérents (une seul mot clé par tag, pas de #)</li>
                <li>fichier audio correct au format mp3</li>
            </ul>
            <button type="submit" class="btn btn-primary" v-bind:disabled="editPending">Publier</button>
        </div>

        <div v-else>
            <h4>publication impossible pour le moment</h4>
            <p>conditions nécessaires pour publication :</p>
            <ul>
                <li>statut confirmé, avec les éléments suivants :
                  <ul>
                    <li>rubrique et format renseignés</li>
                    <li>un invité validé, ou 'validation chroniqueur' sélectionnée</li>
                    <li>titre du podcast</li>
                    <li>description</li>
                    <li>tag principal renseigné</li>
                    <li>fichier image présent</li>
                  </ul>
                </li>
                <li>fichier audio du podcast présent</li>
            </ul>
        </div>

        <div v-if="subject.mixcloudURL === 'ERREUR UPLOAD MIXCLOUD'">
            <b-alert variant="danger" show>Erreur durant la publication du sujet</b-alert>
            <button type="submit" class="btn btn-primary" v-bind:disabled="editPending">Republier</button>
        </div>
    </form>
</template>

<script>

  export default {

    name: 'PublicationForm',

    props: {
      subject: Object,
      statut: Object,
      editPending: false
    },

    methods: {
      publish: function (e) {
        e.preventDefault()
        console.log('test')
        this.$emit('publish')
      },
    }

  }

</script>



// WEBPACK FOOTER //
// src/components/EditSub/PublicationForm.vue